/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyItemDTO } from './CompanyItemDTO';
import {
    CompanyItemDTOFromJSON,
    CompanyItemDTOFromJSONTyped,
    CompanyItemDTOToJSON,
} from './CompanyItemDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface CompanyItemPageDTO
 */
export interface CompanyItemPageDTO {
    /**
     * 
     * @type {Array<CompanyItemDTO>}
     * @memberof CompanyItemPageDTO
     */
    content?: Array<CompanyItemDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyItemPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyItemPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyItemPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyItemPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof CompanyItemPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof CompanyItemPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof CompanyItemPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof CompanyItemPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyItemPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the CompanyItemPageDTO interface.
 */
export function instanceOfCompanyItemPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompanyItemPageDTOFromJSON(json: any): CompanyItemPageDTO {
    return CompanyItemPageDTOFromJSONTyped(json, false);
}

export function CompanyItemPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyItemPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(CompanyItemDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function CompanyItemPageDTOToJSON(value?: CompanyItemPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(CompanyItemDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

